import * as React from 'react';
import { connect } from 'react-redux';
import { createUser, getOrgUsers, setUserCurrentPage } from '~/apps/shared/actions/users';
import { getOrgLocations, getLocationById } from '~/apps/shared/actions/locations';
import UserCreateFormOverlay from '../../components/users/UserCreateFormOverlay';
import Loader from '~/common/components/Loader';
import { Features, UserRole } from '~/apps/shared/consts';
import {createOrgLocationsHelper} from "~/apps/shared/services/forms";
import {SearchableModelHelper} from "~/lib/forms/select";

class UserCreatePopup extends React.Component<any, any> {
  locationHelper: SearchableModelHelper;

  refresh = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    const { dispatch, orgId, currentUser: { role, locationId } } = this.props;

    if (role == UserRole.WAREHOUSE_MANAGER) {
      dispatch(getLocationById(locationId));
    } else {
      this.locationHelper = createOrgLocationsHelper(this.refresh, orgId,  {
        label: '- Without Location -',
        value: null,
      });
    }

    dispatch(getOrgLocations(orgId, null, 0, 100));
  }

  onSubmit = (data) => {
    const { dispatch } = this.props;
    const req = {
      ...data,
      locationId: !data.locationId ? '' : data.locationId,
      departmentId: !data.departmentId ? null : data.departmentId,
    };

    return dispatch(createUser(req))
      .then(() => {
        dispatch(getOrgUsers()).then(() => {
          dispatch(setUserCurrentPage(0));
        })
        this.props.onReturn();
      });
  };

  onClose = () => {
    this.props.onReturn();
  };

  getWarehouseManagerLocationsOptions = () => {
    const { locations: { entities }, currentUser: { role, locationId } } = this.props;

    // if user is not a WAREHOUSE MANAGER we are working with locationHelper
    if (role != UserRole.WAREHOUSE_MANAGER) {
      return null;
    }

    if (!entities?.[locationId]) return [];

    return [{
      label: entities[locationId].name,
      value: locationId,
    }];
  };


  render() {
    const { errorMessage, loading, currentUser, information, departments } = this.props;

    const hasDepartmentFeature = information.entities.features.includes(Features.DEPARTMENTS);
    const hasFHIFeature = information.entities.features.includes(Features.FHI);
    const departmentOptions = departments.ui.currentList.map(id => {
      const dep = departments.entities[id];

      return {
        label: dep.name,
        value: dep.id,
        locationId: dep.locationId,
      }
    });

    if (loading) {
      return (
        <Loader className="load--ol" />
      );
    }

    return (
      <UserCreateFormOverlay
        headTitle="New User"
        onSubmit={this.onSubmit}
        onClose={this.onClose}
        errorMessage={errorMessage}
        locations={this.getWarehouseManagerLocationsOptions()}
        locationHelper={this.locationHelper}
        currentUser={currentUser}
        hasDepartmentFeature={hasDepartmentFeature}
        departmentOptions={departmentOptions}
        hasFHIFeature={hasFHIFeature}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.shared.locations,
    currentUser: state.shared.auth.currentUser,
    errorMessage: state.shared.users.ui.errorMessage,
    loading: state.shared.users.ui.loading,
    information: state.shared.information,
    departments: state.shared.departments,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCreatePopup) as any;
